import { render, staticRenderFns } from "./MediaPackageEdit.vue?vue&type=template&id=e687c5c8&"
import script from "./MediaPackageEdit.vue?vue&type=script&lang=ts&"
export * from "./MediaPackageEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports